import React from 'react'

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getBloodTestsByUserId, getBloodTestsDatesByUserId } from '../../../../../../service-layer/PatientService';
import ClipLoader from "react-spinners/ClipLoader";

import LogoutModal from '../../../../../components/logout-moal/LogoutModal';

import { CAccordion, CAccordionBody, CAccordionItem, CAccordionHeader, CRow } from '@coreui/react';
import { useTranslation } from 'react-i18next';

import { useStateContext } from '../../../../../../contextProvider';

import './BloodTestsPage.css'


const BloodTestsPage = () => {

const navigate = useNavigate();
const { t } = useTranslation()


useEffect(() => {
  if (window.localStorage.getItem("auth_token") === null) navigate("/login");
}, [navigate]);


const token = window.localStorage.getItem("auth_token");

// STATES & CONTEXT
const { selectedPatient, setSelectedPatient, selectedPatientData, 
  setSelectedPatientData, doctorPage, setDoctorPage } = useStateContext()   // stati condivisi
 
const [showLogoutModal, setShowLogoutModal] = useState(false);  // logout modal
const [showGetError, setShowGetError] = useState(false) // messaggio errore caricamento


const [bloodTestsList, setBloodTestsList ] = useState([])   // lista analisi sangue/colesterolo
const [loading, setLoading] = useState(true)   // stato per spinner

// FUNCTION TO HANDLE LOGOUT
const handleConfirm = () => {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("name");
  localStorage.removeItem("surname");
  localStorage.removeItem("authority");

  localStorage.removeItem("doctor_page");
  localStorage.removeItem("patient_id");
  localStorage.removeItem("staff_id");
  localStorage.removeItem("patient_data");

  localStorage.removeItem("patient_name");
  localStorage.removeItem("patient_surname");

  setSelectedPatient(undefined)
  setSelectedPatientData(undefined)
  setDoctorPage(undefined)

  setShowLogoutModal(false);
  navigate("/");
};

// mapping fra valore e tipologia di esami
const type_mapping = ["no_type","emocromocitometrico","elettroforesi"]


// UPLOAD BLOOD TESTS RESULTS FOR THE USER
useEffect(() => {
  getBloodTestsByUserId(selectedPatient).then((response) => {
    setShowGetError(false)

    if(response.data)  // se !== undefined/null
      groupBloodTests(response.data)
    else
      setBloodTestsList([])

    setLoading(false)
  })
  .catch((err) => {
    console.error(err)
    setShowGetError(true)
    setLoading(false)
  })
}, [])


const groupBloodTests = (data) => {
  // raggruppo tutte le misurazioni nelle analisi del sangue/colesterolo
  // quelle che hanno solo dal 36 al 38 sono colesterolo, quelle dal 36 al 76 invece sono analisi del sangue
  // da 52 a 68 sono Esame emocromocitometrico, da 69 a 76 sono elettroforesi sieroproteine

//   measurementDate:  "2024-06-14T17:42:17.676"
//   measurementDescription:  "Colesterolo totale"
//   measurementId: 36
//   measurementValue: 30
//   unitOfMeasurement: "mg/dl"

let groupedData = []
let k=0

data.forEach((value, ind) => {

  const meas_info = {
    description: value.measurementDescription,
    value: Number.isInteger(value.measurementValue) ? parseInt(value.measurementValue) : parseFloat(value.measurementValue),
    uom: value.unitOfMeasurement,
    type: value.measurementId < 52 ? 0 : ( value.measurementId < 69 ? 1 : 2 )
  }


  if(ind === 0){
    groupedData.push({
      measurementTitle: "",
      measurementDate: new Date(value.measurementDate),
      measurements: [meas_info],
    })
  }
   

  if(ind>0 && ind < data.length - 1){

    if(data[ind].measurementId === 38 && data[ind+1].measurementId !== 39 ){
      // significa che la misurazione nel suo complesso è solo di colesterolo
      groupedData[k].measurements.push(meas_info)
      groupedData[k].measurementTitle = "cholesterol"

      k += 1
    }
    else if(data[ind].measurementId === 36){
      groupedData.push({
        measurementTitle: "",
        measurementDate: new Date(value.measurementDate),
        measurements: [meas_info],
      })
    }
    else if(data[ind].measurementId === 76){
      groupedData[k].measurements.push(meas_info)
      groupedData[k].measurementTitle = "blood_test"

      k += 1
    }
    else{
      groupedData[k].measurements.push(meas_info)
    }

  }

  if(ind === data.length-1){
    groupedData[k].measurements.push(meas_info)
    groupedData[k].measurementTitle = value.measurementId === 76 ? "blood_test" : "cholesterol"
  }

})

  groupedData.sort((a,b) => b.measurementDate - a.measurementDate)

  console.log("GROUPED BLOOD TESTS", groupedData)

  getBloodTestsDatesByUserId(selectedPatient).then((response) => {
    const dates = response.data

    dates.forEach((date, ind) => {
      const dateObj = new Date(date)
      groupedData[ind].measurementDate = dateObj
    })

    setBloodTestsList(groupedData)

  })
}




  return (
    <>
    {
       token && 
       <div
          className="dashboard d-flex grid-container"
          style={{
            flex: "1 1 auto",
            display: "flex",
            flexFlow: "column",
            height: "100vh",
            overflowY: "auto"}}
        >
            <div
            style={{
              flex: "1 1 auto",
              display: "flex",
              flexFlow: "column",
              height: "100vh",
              overflowY: "auto",
              padding: '10px'
            }}
          >
            { bloodTestsList.length > 0 && !loading && !showGetError &&
                bloodTestsList.map((test, ind, arr) => {
                  const lang = t('cholesterol') === 'Colesterolo' ? 'it' : 'en'

                  const datePart = test.measurementDate.toLocaleDateString(lang==='en' ? 'en-GB' : 'it-IT', { year: 'numeric', month: 'long', day: '2-digit' });
                  const timePart = test.measurementDate.toLocaleTimeString(lang==='en' ? 'en-GB' : 'it-IT', { hour: 'numeric', minute: '2-digit', hour12: lang === 'en' ? true : false });

                  let print_date = true

                  if(ind !== 0){
                    // console.log("DATE i-1", new Date(arr[ind-1].measurementDate.getDate()))
                    
                    if(test.measurementDate.getDate() !== arr[ind-1].measurementDate.getDate())
                      print_date = true
                    else
                      print_date = false
                  }
                    

                  return (
                    <>
                    { print_date &&
                        <CRow key={ind+'item_date'}>
                          <div style={{ marginTop: '20px' }}>
                            <span className='date-text'>{datePart}</span>
                          </div>
                        </CRow>
                    }
                    <div style={{borderRadius: '15px', borderColor: '#204770', marginTop: '10px'}}>
                    <CAccordion flush key={ind}>
                      <CAccordionItem itemKey={ind+'item'}
                      >
                          <CAccordionHeader>
                            <span className='header-text'>{t(test.measurementTitle) + '   -   ' + timePart.toUpperCase()}</span>
                          </CAccordionHeader>
                          <CAccordionBody>
                              {
                                test.measurementTitle === 'cholesterol' &&
                                <div style={{backgroundColor: 'white', height: '100%', borderRadius: '15px', padding: '10px'}}>
                                  {
                                    test.measurements.map((meas, i) => 
                                      <p key={ind+'_p_'+i}>
                                        <span className='meas-title'>{t(`${meas.description}`)}: </span>
                                        <span className='meas-value'>{meas.value} {meas.uom}</span>
                                      </p>
                                    )
                                  }
                                </div>
                              }
                              {
                                test.measurementTitle === 'blood_test' &&
                                <div style={{
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(3,1fr)',
                                  backgroundColor: 'white', height: '100%', borderRadius: '15px', padding: '10px'
                                }}>
                                   {
                                    type_mapping.map((type_name, type_index) => {

                                      const exam_type_values = test.measurements.filter((meas) => meas.type === type_index)

                                      return (
                                        <div key={'blood_test_category_'+type_index}>
                                          { t(type_name) && <div className='test-category'>{ t(type_name) }</div>}
                                          { !t(type_name) && <div className='test-category-empty'>&nbsp;</div>}
                                          {
                                            exam_type_values.map((meas, k) => (
                                              <p key={'blood_test_category_p_'+k}>
                                               <span className='meas-title'>{t(`${meas.description}`)}: </span> 
                                               <span className='meas-value'>{meas.value}{meas.uom === '%' ? meas.uom : ' '+meas.uom}</span>
                                              </p>
                                            ))
                                          }
                                        </div>
                                      )
                                    })
                                   }
                                </div>
                              }
                          </CAccordionBody>
                      </CAccordionItem>
                    </CAccordion>
                    </div>
                  </>
                  )
                }
                ) 
            }
            {
              bloodTestsList.length === 0 && !loading && !showGetError &&
              <div
                  style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                  }}
              >
                  <h3>{t("no_blood_tests")}</h3>
              </div>
            }
            {
              showGetError &&
              <div
                  style={{
                      height: "100%",
                      display: "flex",
                      // alignItems: "center",
                      justifyContent: "center",
                  }}
              >
                  <h3>{t("blood_tests_error")}</h3>
              </div>
            }
          </div>
       </div>
    }
    {!token && <div className="login-container"></div>}
      <LogoutModal
        show={showLogoutModal}
        handleConfirm={handleConfirm}
        handleClose={handleConfirm}
        title={t("login")}
        message={t("session_expired_please_login_again")}
        tag={"Login"}
      />
      {
        loading && 
        <div
          style={{
            height: "100%",
            width: '100%',
            display: "flex",
            // alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ClipLoader
            color="#204770"
            loading={loading}
            // cssOverride={override}
            size={100}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
        </div>
      }
    </>
)
}

export default BloodTestsPage